import { createSelector } from "reselect";
import { changePasswordSelector } from "../change_password_selector";

export const changePasswordLoadStateSelector = createSelector(
  changePasswordSelector,
  changePassword => {
    return changePassword.loadState;
  }
);
